import { Toaster as Sonner, type ToasterProps } from "sonner";
import { useThemeContext } from "../ThemeContext";

export function Toaster({ ...props }: ToasterProps) {
  const { isLight } = useThemeContext();

  return (
    <Sonner
      theme={isLight ? "light" : "dark"}
      position="top-right"
      expand={false}
      richColors
      closeButton
      offset={{ top: "5.5rem", right: "1.25rem" }}
      gap={12}
      visibleToasts={4}
      toastOptions={{
        duration: 5000,
        classNames: {
          toast: isLight
            ? "!rounded-xl !border !border-zinc-200/80 !bg-white/95 !backdrop-blur-xl !shadow-xl !shadow-fuchsia-500/10 !px-4 !py-3"
            : "!rounded-xl !border !border-white/10 !bg-[#12121c]/95 !backdrop-blur-xl !shadow-2xl !shadow-fuchsia-500/15 !px-4 !py-3",
          title: isLight
            ? "!text-zinc-900 !font-semibold !text-sm !leading-snug"
            : "!text-white !font-semibold !text-sm !leading-snug",
          description: isLight ? "!text-zinc-600 !text-xs" : "!text-zinc-400 !text-xs",
          success: isLight ? "!border-emerald-400/50 !bg-emerald-50/90" : "!border-emerald-500/30 !bg-emerald-500/5",
          error: isLight ? "!border-red-400/50 !bg-red-50/90" : "!border-red-500/30 !bg-red-500/5",
          info: isLight ? "!border-blue-400/50 !bg-blue-50/90" : "!border-blue-500/30 !bg-blue-500/5",
          closeButton: isLight
            ? "!bg-zinc-100 !border-zinc-200 !text-zinc-500 hover:!text-zinc-800"
            : "!bg-white/5 !border-white/10 !text-zinc-400 hover:!text-white",
        },
      }}
      {...props}
    />
  );
}
